import React, { useState } from 'react';
 import { ChevronDown } from "lucide-react";
import COLORS from '../../../constants/colors.js';

const faqData = [
  {
    question: 'What are PFAS chemicals?',
    answer:
      ' PFAS are man-made chemicals used in water-resistant and non-stick products, firefighting foam, and industrial applications. They are toxic and persist in the environment and bloodstream.'
  },
  {
    question: 'How do I know if I was exposed?',
    answer:
      ' If you lived near a known PFAS contamination site or used PFAS-laced water, you may qualify. Your legal team can help investigate your exposure.'
  },
  {
    question: 'Which companies are being sued?',
    answer:
  'Major defendants include 3M, DuPont, Chemours, and others involved in PFAS production and distribution.'
  },
  {
    question: 'Is this a class action or individual lawsuit?',
    answer:
      ' These are typically mass tort claims filed individually. Compensation is based on your specific health and exposure history.',
  },
  {
    question: 'What if a loved one passed away from a PFAS-related illness?',
    answer:
      'You may be able to file a wrongful death claim on their behalf.',
  },
];


const PFASSeven = () => {
  const [activeIndex, setActiveIndex] = useState(null); // No dropdown open by default

  const toggle = (idx) => {
    setActiveIndex(idx === activeIndex ? null : idx);
  };

  return (
    <section className="py-12 px-2 sm:px-4 md:px-8 lg:px-16 w-full max-w-none" style={{ fontFamily: 'Quicksand, sans-serif' }}>
      {/* Title */}
      <h2
        className="text-[32px] sm:text-[40px] font-semibold mb-6 capitalize leading-none"
        style={{ color: COLORS.darkBlueAlt }}
      >
        Frequently Asked{' '}
        <span style={{ color: COLORS.yellow, fontWeight: 'semibold' }}>
          Questions
        </span>
      </h2>

      {/* Accordion */}
      <div className="space-y-4">
        {faqData.map((item, idx) => (
          <div key={idx} className="border border-gray-200 rounded overflow-hidden">
            <button
              onClick={() => toggle(idx)}
              className={`w-full text-left px-4 py-3 flex justify-between items-center transition`}
              style={{ 
                fontFamily: 'Quicksand, sans-serif',
                backgroundColor: activeIndex === idx ? COLORS.lightBlueAlt : COLORS.white
              }}
            >
              <span className="text-[20px] sm:text-[24px] font-semibold leading-normal"
                    style={{ color: COLORS.darkBlueAlt }}>
                {item.question}
              </span>
             <span className="text-[18px] font-light select-none">
                <ChevronDown
                  className={`w-5 h-5 transform transition-transform duration-300`}
                  style={{ 
                    transform: activeIndex === idx ? "rotate(180deg)" : "rotate(0deg)",
                    color: activeIndex === idx ? COLORS.yellow : COLORS.darkBlueAlt
                  }}
                />
              </span>
            </button>
            {activeIndex === idx && (
              <div className="px-4 pb-4 pt-1 text-[18px] sm:text-[20px] font-medium leading-normal"
                   style={{ 
                     fontFamily: 'Quicksand, sans-serif',
                     color: COLORS.gray,
                     backgroundColor: COLORS.lightBlueAlt
                   }}>
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default PFASSeven;
